<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <!-- Submenu -->
          <div class="sub-menu">
            <router-link
              to="/tickets"
              custom
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <div :class="{ active: isExactActive }" @click="navigate">
                My tickets
              </div>
            </router-link>
            <router-link
              to="/tickets/all"
              custom
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <div :class="{ active: isExactActive }" @click="navigate">
                All tickets
              </div>
            </router-link>
            <router-link
              to="/tickets/search"
              custom
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <div :class="{ active: isExactActive }" @click="navigate">
                Search tickets
              </div>
            </router-link>
              <router-link
              to="/tickets/new"
              custom
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <div :class="{ active: isExactActive }" @click="navigate">
                Create new ticket
              </div>
            </router-link>
            <div class="active" v-if="$route.name === 'View ticket'">
              View ticket
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
